export enum E_SmartDisplayGraphResult {
    First = 'First',
    Last = 'Last',
    Sum = 'Sum',
    Min = 'Min',
    Max = 'Max',
    Average = 'Average',
    Count = 'Count',
    Shift = 'Shift',
    /*
     * Rellena las horas que no tienen valor con la ultima media hora del anterior en caso de haberla.
     * Al pedir las observaciones a la bd, devuelve todas las observaciones de la hora
     */
    HalfHour = 'HalfHour',
    /*
     * Devuelve valor para todas las horas puestas en el max, Rellenando con el valor anterior de no haber ninguno en esas horas.
     */
    LastFilled = 'LastFilled',
    /*
     * Igual que el last filled pero no rellena con el valor anterior en caso de no haberlo. Mirar si last puede ser así siempre, creo que si
     * (caso diuresis grafica,)
     * No devuleve valores??
     */
    LastAll = 'LastAll',
    Hour = 'Hour',
}
